<script setup lang="ts">
import {
  Attachment,
  AttachmentPreview,
  Attachments,
} from '@/Components/Agent/Attachments'
import { XMarkIcon } from '@heroicons/vue/20/solid'
import { computed } from 'vue'
import { usePromptInput } from './context'

const { files, removeFile } = usePromptInput()

const attachments = computed(() => files.value)
</script>

<template>
  <Attachments v-if="attachments.length > 0" variant="inline">
    <Attachment
      v-for="attachment in attachments"
      :key="attachment.id"
      :data="attachment"
      class="max-w-full text-gray-700 dark:text-gray-200"
      @remove="removeFile(attachment.id)"
    >
      <AttachmentPreview />

      <span class="truncate">
        {{ attachment.filename || 'Attachment' }}
      </span>

      <button
        type="button"
        class="rounded p-0.5 text-gray-400 hover:bg-gray-200 hover:text-gray-700 dark:hover:bg-white/10 dark:hover:text-white"
        aria-label="Remove attachment"
        @click="removeFile(attachment.id)"
      >
        <XMarkIcon class="h-3.5 w-3.5" />
      </button>
    </Attachment>
  </Attachments>
</template>
